export default __webpack_public_path__ + "static/media/variluxG9-bg-3.e2fa4688.webp";